import { WebSocketChannel } from "../../types/WebSocketChannel";
import type { WebSocketActionMessage } from "../../types/WebSocketMessage";
import { useWebSocketListener } from "./useWebSocketListener";
import { useActions } from "@huub-web/ui";

/**
 * Hook for handling WebSocket actions.
 * @deprecated This hook is should not be used other then in AppController. Use useActions if needed elsewhere.
 */
export const useWebSocketActions = () => {
  const { handleAction } = useActions();

  useWebSocketListener<WebSocketActionMessage>(
    WebSocketChannel.ACTION,
    (message) => {
      if (message?.data) {
        handleAction(message.data);
      } else {
        console.warn("Unknown or incorrect action", message);
      }
    },
  );
};
